"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var reference_exports = {};
__export(reference_exports, {
  ReferenceNode: () => ReferenceNode
});
module.exports = __toCommonJS(reference_exports);
var import_core = require("@tiptap/core");
var import_utils = require("./utils");
const ReferenceNode = import_core.Node.create({
  name: "reference",
  group: "inline",
  inline: true,
  selectable: true,
  addAttributes() {
    return {
      id: (0, import_utils.getDataAttribute)("id"),
      objectclass: (0, import_utils.getDataAttribute)("objectclass"),
      label: (0, import_utils.getDataAttribute)("label"),
      grantsAccess: {
        // V3: keep the deny flag across edit round-trips. parseHTML normalises
        // a missing attribute to `undefined` rather than `null` so the runtime
        // value matches the public type `'true' | 'false' | undefined` declared
        // on ReferenceMarkupNode.attrs — a `null` would break strict
        // `=== undefined` checks downstream.
        default: void 0,
        parseHTML: /* @__PURE__ */ __name((element) => element.getAttribute("data-grants-access") ?? void 0, "parseHTML"),
        renderHTML: /* @__PURE__ */ __name((attributes) => attributes.grantsAccess == null ? null : { "data-grants-access": attributes.grantsAccess }, "renderHTML")
      },
      fixed: {
        default: null,
        parseHTML: /* @__PURE__ */ __name((element) => element.getAttribute("data-fixed") === "true", "parseHTML"),
        renderHTML: /* @__PURE__ */ __name((attributes) => {
          if (attributes.fixed !== true) {
            return {};
          }
          return {
            "data-fixed": "true"
          };
        }, "renderHTML")
      }
    };
  },
  addOptions() {
    return {
      suggestion: { char: "@" },
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        priority: 60,
        tag: 'span[data-type="reference"]',
        getAttrs
      },
      {
        priority: 60,
        tag: 'a[data-type="reference"]',
        getAttrs
      }
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      (0, import_core.mergeAttributes)(
        {
          "data-type": this.name,
          "data-id": node.attrs.id,
          "data-objectclass": node.attrs.objectclass,
          "data-label": node.attrs.label,
          // V3: belt-and-suspenders — explicitly emit data-grants-access here
          // (in addition to the per-attribute renderHTML in addAttributes) so
          // the deny flag is rendered even if the attribute-renderer merge
          // path is bypassed by a downstream override.
          ...node.attrs.grantsAccess != null ? { "data-grants-access": node.attrs.grantsAccess } : {},
          class: "antiMention"
        },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
      `${this.options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
    ];
  }
});
function getAttrs(el) {
  const id = el.dataset.id?.trim();
  const label = el.dataset.label?.trim();
  const objectclass = el.dataset.objectclass?.trim();
  const fixed = el.getAttribute("data-fixed") === "true";
  if (id == null || label == null || objectclass == null) {
    return false;
  }
  const grantsAccess = el.dataset.grantsAccess;
  return {
    id,
    label,
    objectclass,
    ...grantsAccess !== void 0 ? { grantsAccess } : {},
    fixed: fixed || null
  };
}
__name(getAttrs, "getAttrs");
//# sourceMappingURL=reference.js.map
